import styled from 'styled-components';

export const StyledMetaItem = styled.div`
    display: flex;
    align-items: baseline;
    width: 50%;
    column-gap: 8px;
    min-width: 0;

    .label {
        color: #6d6d6d;
        font-size: 14px;
        padding-left: 0;
        font-weight: 400;
        flex-shrink: 0;
        white-space: nowrap;
    }

    .value {
        overflow: hidden;
        text-overflow: ellipsis;
    }
`;
